<template>
    <div>

        <div class="coursebox f-cb auto-1603067944656-parent" id="j-coursebox">
            <div class="m-courselb">
                <div class="cl-bg"></div>
                <a hidefocus="true" id="j-back" class="cl-back" href="javascript:;" @click="courseDetail()">返回课程详情</a>
                <a hidefocus="true" id="j-prev" class="cl-pre" style="display:none"></a>
                <div id="course-learn-box" class="course-learn">
                    <div class="m-courselearn">
                        <p class="cl-title f-thide j-clTitle" style="display: flex;">
                            <span class="cl-chapter j-chapter" id="j_chapter">章节</span>
                            <span class="cl-lesson j-lessonIndex"></span>
                            <span class="cl-lessonnum j-lessonnum" id="j_lessonnum"></span><span
                                class="cl-lessonname j-lessonname" id="chapterName">{{chapterName}}</span>
                        </p>
                        <div class="learn-total">
                            <div id="lesson-learn-box" class="learn-box" style="height: 100%;">
                                <div class="m-video-box">
                                    <div class="j-videobox">
                                        <div id="auto-id-1603067944457"></div>
                                        <div class="ux-video-player">
                                            <div class="u-edu-h5player" id="auto-id-1603067944470">
                                                <div class="bg f-pa j-playerbg"></div>
                                                <div class="u-edu-h5player-mainvideo f-pa j-mainVideo" id="videoView"
                                                    style="height: 100%;">

                                                    <video download="false" width="100%" height="100%"
                                                        controlslist="nodownload"
                                                        poster="../../../static/img/courseVideoImg.jpg"
                                                        id="videoContent" controls="controls" :src="video_src"
                                                        @play="onplay1" @pause="pause" @ended="videoEndMonitoring"
                                                        @timeupdate="timeupdate">
                                                    </video>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="course-toolbar-box" class="g-sd2">
            <div class="m-ctb">
                <div class="courseintro">
                    <div class="f-fl courseTitle j-courseintro">
                        <div class="u-coursetitle f-fl"><a href="" target="_blank" class="j-info f-thide"
                                id="class_title">{{courseName}}</a>
                            <div class="f-cb"><span class="j-info starall">
                                    <div class="u-rating" id="auto-id-1603067944495">
                                        课时:
                                    </div>
                                </span><span class="cmt j-cmt" id="coursePeriod">{{coursePeriod}}</span>
                            </div>
                            <p class="j-info f-thide" id="teaName">教师名称：{{teacherName}}</p>
                        </div>
                    </div>
                    <a class="j-courseimg-link courseImgCover" id="class_Pic" href="javascript:;"><img
                            class="f-fr courseImg j-courseimg" src="../../../static/img/majorCourse.jpg"></a>
                </div>
                <div class="tabs j-tab-tabwrap"><a class="tabitem j-tab-tabitem tab-forum tabitem-pos"
                        id="auto-id-1603067944498"><span class="f-fl tabicon tabicon-pos0"></span><span
                            class="f-fl">目录</span></a>
                    <a class="tabitem j-tab-tabitem" style="display:none;" id="auto-id-1603067944504"><span
                            class="f-fl tabicon tabicon-3"></span><span class="f-fl">问答</span></a>
                </div>
                <div id="toolbar-box" class="tabarea j-tabarea">
                    <div class="tabbox j-tabbox" id="chapterList-tabbox" style="display: block;">
                        <div class="bd j-bd"></div>
                        <div id="tb-chapterlist-box" class="m-chapterlistBox">
                            <div class="m-chapterList" id="auto-id-1603067944520">

                                <a class="courseChapter_click" v-for="(item,index) in courseChapterList" :key="index"
                                    @click="chapterCut(item,index)">
                                    <div class="section" :class="item.state === 2?'section-cur':''">
                                        <span class="f-fl f-thide1 trailer-ks"
                                            style="color: rgb(153, 153, 153);">{{item.schedulePercentage}}%</span>

                                        <span class="f-fl ksw"
                                            :style="item.state === 2?'background-color: #3a3e4a;':''">
                                            <p></p><span class="u-clicon ksicon ksicon-0" title="未完成"></span>
                                        </span>

                                        <span class="f-fl ksname"
                                            style="color: rgb(153, 153, 153);">{{item.chapterName}}</span><span
                                            class="f-fr ksinfo"><span class="f-fr ksinfoicon ksinfoicon-2"
                                                title="视频"></span><span
                                                class="f-fr kstime">{{item.totalHourMinuteSecond}}</span><span
                                                class="f-fr flag flag-0" title=""></span></span>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="tabbox j-tabbox" id="forum-tabbox"></div>
                    <div class="tabbox j-tabbox" id="note-tabbox"></div>
                    <div class="tabbox asktabbox j-tabbox" id="ask-tabbox"></div>
                </div>
            </div>
        </div>

        <div class="camera_outer" style="width: 150px;height: 150px;position: fixed;top: 13.3%;left:1.5%">
            <video id="videoCamera" :width="videoWidth" :height="videoHeight" autoplay
                style="width: 100%; height: 100%;"></video>
            <canvas style="display: none" id="canvasCamera" :width="videoWidth" :height="videoHeight"></canvas>
            <div v-if="imgSrc" class="img_bg_camera">
                <img :src="imgSrc" alt="" class="tx_img" />
            </div>
            <!--  <button @click="getCompetence()">打开摄像头</button>
            <button @click="stopNavigator()">关闭摄像头</button>
            <button @click="setImage()">拍照</button> -->
        </div>
    </div>
</template>
<script>
    var beginDate = null;
    import Vue from 'vue'
    import vuebeauty from 'vue-beauty'
    import 'vue-beauty/package/style/vue-beauty.min.css'
    Vue.use(vuebeauty);
    export default {
        name: 'app',
        components: {

        },
        data() {
            return {
                addLearningRecordsIndex: '', //学习时间更新
                minVlue: 8,  //第一次对比时间 （多少秒 每个章节默认对比两次）
                maxVlue: 200,//第二次对比时间 （多少秒 每个章节默认对比两次  第一次5秒 第二次随机时间）
                timeUpdateSwitch: false,
                currentTime: 0,
                workTypeId: 0,
                teacherName: '',
                courseName: '',
                coursePeriod: '',
                courseChapterList: [],
                flag: true,
                chapterId: 0,
                chapterName: '',
                resourcePath: '',
                totalSecond: 0,
                video_src: '',
                speedProgress: 0,
                studyState: 1,
                classHour: 0,
                courseType: 0,
                videoWidth: 300,
                videoHeight: 300,
                imgSrc: "",
                thisCancas: null,
                thisContext: null,
                thisVideo: null,
                playSwitch: true,
                playlivingbodySwitch:false
            }
        },
        created() {

            //加载章节信息
            this.laodChaterDate(this.$route.params.courseId, this.$route.params.classId);
        },

        mounted() {

            //document.getElementById("videoContent").bind('contextmenu', function () { return false; });

            //禁止鼠标右键的另存为功能
            document.getElementById("videoContent").oncontextmenu = function(){

                event.returnValue = false;

            }
            //是否开启人脸比对服务服务
            if (this.$route.params.compareCourseFace === '1') {
                this.getCompetence(); //人脸比对开启 开启摄像头
            }


        },

        watch: {
            currentTime(newVlue, oldvalue) {

                if (this.$route.params.compareCourseFace === '1') {


                    //人脸比对开启 两次人脸比对 要符合两次对比时间
                    if (oldvalue === this.minVlue || oldvalue === this.maxVlue) {

                        this.$message({
                            showClose: true,
                            message: '即将进行人脸比对，请保持脸部与摄像头平齐',
                            duration: 2000
                        });

                        let _this = this;

                        setTimeout(() => {
                            _this.faceCompare();
                        }, 2000)


                    }
                }
            }
        },
        methods: {
            pause() {

                if (this.addLearningRecordsIndex) {
                    clearInterval(this.addLearningRecordsIndex);
                }
                //console.log("123456789");
                this.addLearningRecords();
            },
            //30秒一次 更新学习时间  累计超过8小时就不让学习了
            addLearningRecords() {

                let parames = new URLSearchParams();
                parames.append('userId', this.$storage.get("declareUser").id);
                parames.append('userName', this.$storage.get("declareUser").userName);
                parames.append('idCard', this.$storage.get("declareUser").idCard);
                parames.append('classId', this.$route.params.classId);
                parames.append('courseId', this.$route.params.courseId);
                parames.append('courseName', this.courseName);
                parames.append('chapterId', this.chapterId);
                parames.append('chapterName', this.chapterName);

                parames.append('beginTime', beginDate);
                parames.append('endTime', this.getCurrentTime());

                parames.append('studyType', 1);
                parames.append('studyDesc', '视频学习');

                this.$axios.post(this.serverUrl + '/records/addLearningRecords', parames).then(resp => {


                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })

            },
            randomNum(minNum, maxNum) {
                switch (arguments.length) {
                    case 1:
                        return parseInt(Math.random() * minNum + 1, 10);
                        break;
                    case 2:
                        return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
                        break;
                    default:
                        return 0;
                        break;
                }
            },
            //五秒比对检测是否有人脸
            isThereFace() {

                let res_video = document.getElementById("videoContent");

                // 点击，canvas画图
                this.thisContext.drawImage(
                    res_video,
                    0,
                    0,
                    this.videoWidth,
                    this.videoHeight
                );
                // 获取图片base64链接
                var image = this.thisCancas.toDataURL("image/png");

                let jsonObj = {
                    aac002: this.$storage.get("declareUser").idCard,//身份证号码
                    aac003: this.$storage.get("declareUser").userName,//姓名
                    kjmc: this.chapterName,//课件名称  （章节名称）
                    spsc: this.totalSecond,//视频时长  秒
                    xxsc: Math.ceil(res_video.currentTime),//学习时长  秒
                    headPath: this.$storage.get("declareUser").headPath,//头像
                    photo: image,//抓拍照片  bas64
                }

                let jsonStr = JSON.stringify(jsonObj);


                let parames = new URLSearchParams();
                parames.append('jsonObject', jsonStr);

                this.$axios.post(this.serverUrl + '/userFaceCompare', parames).then(resp => {

                    if (resp.data.code != '1') {

                        res_video.pause();
                        this.playlivingbodySwitch = true //活体认证不通过 点击开始播放时 禁止播放

                        this.$message({
                            message: '未检测到人脸！',
                            type: 'warning',
                            offset: 400,
                            duration: 1500
                        });

                    } else {
                        res_video.play();
                    }

                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })

            },
            //人脸对比 是否本人
            faceCompare() {
                const loading = this.$loading({
                    lock: true,
                    text: '比对中，请稍后...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let res_video = document.getElementById("videoContent");
                res_video.pause();//先暂停播放视频
                this.playSwitch = false; //人脸对比期间 视频不允许播放

                // 点击，canvas画图
                this.thisContext.drawImage(
                    this.thisVideo,
                    0,
                    0,
                    this.videoWidth,
                    this.videoHeight
                );
                // 获取图片base64链接
                var image = this.thisCancas.toDataURL("image/png");

                let jsonObj = {
                    aac002: this.$storage.get("declareUser").idCard,//身份证号码
                    aac003: this.$storage.get("declareUser").userName,//姓名
                    kjmc: this.chapterName,//课件名称  （章节名称）
                    spsc: this.totalSecond,//视频时长  秒
                    xxsc: Math.ceil(res_video.currentTime),//学习时长  秒
                    photo: image,//抓拍照片  bas64
                }

                let jsonStr = JSON.stringify(jsonObj);


                let parames = new URLSearchParams();
                parames.append('jsonObject', jsonStr);

                this.$axios.post(this.serverUrl + '/userCourseCompare', parames).then(resp => {

                    loading.close();

                    if (resp.data.code === '1') {
                        //人脸对比成功
                        this.$message({
                            message: '人脸对比成功！',
                            type: 'success',
                            offset: 400,
                            duration: 1500
                        });

                        this.playSwitch = true;
                        res_video.play();


                    } else {
                        //人脸对比失败
                        this.$alert('人脸对比失败，请重新对比', '人脸对比', {
                            confirmButtonText: '确定',
                            callback: action => {

                                this.$message({
                                    showClose: true,
                                    message: '即将进行人脸比对，请保持脸部与摄像头平齐',
                                    duration: 2000
                                });

                                let _this1 = this;

                                setTimeout(() => {
                                    _this1.faceCompare();
                                }, 2000)

                                //this.faceCompare();

                            }
                        });

                    }

                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })

            },
            // 调用权限（打开摄像头功能）
            getCompetence() {
                var _this = this;
                this.thisCancas = document.getElementById("canvasCamera");
                this.thisContext = this.thisCancas.getContext("2d");
                this.thisVideo = document.getElementById("videoCamera");
                // 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
                if (navigator.mediaDevices === undefined) {
                    navigator.mediaDevices = {};
                }
                // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
                // 使用getUserMedia，因为它会覆盖现有的属性。
                // 这里，如果缺少getUserMedia属性，就添加它。
                if (navigator.mediaDevices.getUserMedia === undefined) {
                    navigator.mediaDevices.getUserMedia = function (constraints) {
                        // 首先获取现存的getUserMedia(如果存在)
                        var getUserMedia =
                            navigator.webkitGetUserMedia ||
                            navigator.mozGetUserMedia ||
                            navigator.getUserMedia;
                        // 有些浏览器不支持，会返回错误信息
                        // 保持接口一致
                        if (!getUserMedia) {
                            return Promise.reject(
                                new Error("getUserMedia is not implemented in this browser")
                            );
                        }
                        // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
                        return new Promise(function (resolve, reject) {
                            getUserMedia.call(navigator, constraints, resolve, reject);
                        });
                    };
                }
                var constraints = {
                    audio: false,
                    video: {
                        width: this.videoWidth,
                        height: this.videoHeight,
                        transform: "scaleX(-1)",
                    },
                };
                navigator.mediaDevices
                    .getUserMedia(constraints)
                    .then(function (stream) {
                        // 旧的浏览器可能没有srcObject
                        if ("srcObject" in _this.thisVideo) {
                            _this.thisVideo.srcObject = stream;
                        } else {
                            // 避免在新的浏览器中使用它，因为它正在被弃用。
                            _this.thisVideo.src = window.URL.createObjectURL(stream);
                        }
                        _this.thisVideo.onloadedmetadata = function (e) {
                            _this.thisVideo.play();
                        };
                    })
                    .catch((err) => {
                    });
            },
            //  绘制图片（拍照功能）
            setImage() {
                var _this = this;
                // 点击，canvas画图
                _this.thisContext.drawImage(
                    _this.thisVideo,
                    0,
                    0,
                    _this.videoWidth,
                    _this.videoHeight
                );
                // 获取图片base64链接
                var image = this.thisCancas.toDataURL("image/png");
                _this.imgSrc = image;
                this.$emit("refreshDataList", this.imgSrc);
            },
            // base64转文件
            dataURLtoFile(dataurl, filename) {
                var arr = dataurl.split(",");
                var mime = arr[0].match(/:(.*?);/)[1];
                var bstr = atob(arr[1]);
                var n = bstr.length;
                var u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, { type: mime });
            },
            // 关闭摄像头
            stopNavigator() {
                this.thisVideo.srcObject.getTracks()[0].stop();
            },
            courseDetail() {
                this.$router.push({ path: '/courseDetail/' + this.$route.params.courseId + "/" + this.$route.params.classId + "/" + this.workTypeId + "/2" });

            },
            getCurrentTime() {
                //获取当前时间并打印
                var _this = this;
                let yy = new Date().getFullYear();
                let mm = new Date().getMonth() + 1;
                let dd = new Date().getDate();
                let hh = new Date().getHours();
                let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
                let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
                return yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss;
            },
            onplay1() {
                let res_video = document.getElementById("videoContent");

                // if (!this.playlivingbodySwitch) {
                //     //活体认证不通过不让进视频播放
                //     res_video.pause();

                //     //再去调一次活体认证
                //     this.isThereFace();
                // }
                // else if (!this.playSwitch) {
                //     //人脸比对时 视频暂时先停止 不允许播放
                //     res_video.pause();
                //     this.faceCompare();

                // } else {

                    if (this.studyState != 2) {
                        res_video.currentTime = this.speedProgress;
                        this.beginSpeedProgress();
                        this.timeUpdateSwitch = true;
                    }
                    let _this = this;
                    //是否开启人脸比对服务服务
                    if (this.$route.params.compareCourseFace === '1') {


                        //五秒比对检测是否人脸
                        setInterval(() => {

                            _this.isThereFace();
                            //console.log("我叼你妈的！！！！！")

                        }, 10000)
                    }


                    beginDate = this.getCurrentTime();

                    let addLearningRecordsIndex = setInterval(() => {

                        _this.addLearningRecords();

                    }, 120000)

                    this.addLearningRecordsIndex = addLearningRecordsIndex;

                // }
            },
            timeupdate() {

                let res_video = document.getElementById("videoContent");
                let current = res_video.currentTime;
                this.currentTime = Math.ceil(current); //实时更新进度 用于 实时监控 调起摄像头进行人脸对比
                if (this.studyState != 2 && this.timeUpdateSwitch) {

                    if (current - this.speedProgress > 2) {
                        res_video.currentTime = Math.ceil(this.speedProgress);
                    } else {
                        this.speedProgress = Math.ceil(current);
                    }
                }

            },
            //章节切换
            chapterCut(item, index) {
                if (this.playSwitch) {//人脸识别比对不成功 不允许切换章节

                    if (item.indexState != 1) {
                        if (this.courseChapterList[item.indexState - 2].studyState != 2) {
                            this.$message({
                                showClose: true,
                                message: '请将上一个章节学完！',
                                type: 'success'
                            });

                        } else {
                            this.chapterCutM(item, index);
                        }
                    } else {

                        this.chapterCutM(item, index);
                    }

                }

            },
            chapterCutM(item, index) {
                this.timeUpdateSwitch = false;

                let res_video = document.getElementById("videoContent");
                let current = res_video.currentTime;
                this.courseChapterList[this.lastIndex].speedProgress = this.speedProgress;
                this.lastIndex = index;

                this.courseChapterList.forEach(ele => {
                    ele.state = 1;
                })
                this.speedProgress = item.speedProgress;
                this.courseChapterList[index].state = 2;
                this.videoPlay(item.resourcePath, item.totalSecond);
                this.studyState = item.studyState;
                this.classHour = item.classHour;
                this.courseType = item.courseType;
                this.totalSecond = item.totalSecond;
                this.resourcePath = item.resourcePath;
                this.chapterId = item.chapterId;
                this.chapterName = item.chapterName;


                this.maxVlue = this.randomNum(this.minVlue, this.totalSecond); //更新人脸对比 第二次随机对比时间 章节切换数也切换
                console.log("maxVlue==============" + this.maxVlue);
            },
            secondToDate(result) {
                var h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
                var m = Math.floor((result / 60) % 60) < 10 ? '0' + Math.floor((result / 60) % 60) : Math.floor((result / 60) % 60);
                var s = Math.floor(result % 60) < 10 ? '0' + Math.floor(result % 60) : Math.floor(result % 60);
                return (result = h + ':' + m + ':' + s);
            },
            videoPlay(resourcePath, totalSecond) {

                let parames = new URLSearchParams();

                parames.append('vId', resourcePath);
                parames.append('totalSecond', totalSecond);

                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/av/gv', parames).then(resp => {
                    this.video_src = resp.data.u;
                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })
            },
            updateSpeedProgress(speedProgress, studyState) {
                let parames = new URLSearchParams();
                parames.append('courseId', this.$route.params.courseId);
                parames.append('classId', this.$route.params.classId);
                parames.append('chapterId', this.chapterId);
                parames.append('speedProgress', speedProgress);
                parames.append('userId', this.$storage.get("declareUser").id);

                this.$axios.post(this.serverUrl + '/el/updateSpeedProgress', parames).then(resp => {

                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })
            },
            updateSpeedState(studyState, classHour, courseType) {
                let parames = new URLSearchParams();

                parames.append('courseId', this.$route.params.courseId);
                parames.append('classId', this.$route.params.classId);
                parames.append('chapterId', this.chapterId);
                parames.append('classHour', classHour);
                parames.append('studyState', studyState);
                parames.append('courseType', courseType);
                parames.append('userId', this.$storage.get("declareUser").id);

                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/el/updateStudyState', parames).then(resp => {

                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })


            },
            beginSpeedProgress() {
                let this_ = this;
                setInterval(() => {

                    if (this_.studyState != 2) {
                        this_.updateSpeedProgress(Math.ceil(this_.speedProgress), 1);
                    }

                }, 120000)

            },
            videoEndMonitoring() {
                let video1 = document.getElementById("videoContent");

                //判断是否满足结束
                if (this.studyState != 2) {
                    if (this.totalSecond - this.speedProgress > 2) {
                        return false;
                    }
                }
                //判断是否满足结束
                if (this.studyState != 2) {
                    //修改视频进度
                    this.updateSpeedProgress(this.totalSecond, 1);

                    //修改视频学习状态
                    this.updateSpeedState(2, this.classHour, this.courseType);
                }

            },
            laodChaterDate(courseId, classId) {
                let parames = new URLSearchParams();
                parames.append('courseId', courseId);
                parames.append('classId', classId);
                parames.append('userId', this.$storage.get("declareUser").id);
                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/el/selectCourseDetails', parames).then(resp => {

                    if (resp.data.code === '1') {

                        //老师姓名
                        this.workTypeId = resp.data.data.workTypeId;
                        this.teacherName = resp.data.data.teaName;
                        this.courseName = resp.data.data.courseName;
                        this.coursePeriod = resp.data.data.coursePeriod;
                        let ArrayList = [];
                        resp.data.data.courseChapterVos.forEach((element, index) => {

                            let courseChapterVoObjectEnter = {
                                indexState: index + 1,
                                chapterId: 0, //章节id
                                chapterName: '', //章节名称
                                totalHourMinuteSecond: '', //章节 总 时分秒
                                totalSecond: '', //章节 总时长 秒
                                atMostTime: 0, //该章节最多学习到多少秒过
                                speedProgress: '', //学习到多少分 多少秒  用于显示 类型字符串
                                aleryHourMinuteSecond: '', //学习到多少秒 用于直接定义视频播放初始位置  类型数值 秒
                                resourcePath: 0, //资源路径
                                courseType: 0,
                                classHour: 0,
                                studyState: 0,
                                schedulePercentage: 0,
                                state: 1
                            };

                            if (element.chapterId == this.$route.params.chapterId && this.flag) {

                                this.chapterId = element.chapterId;
                                this.totalSecond = element.totalSecond;


                                this.maxVlue = this.randomNum(this.minVlue, this.totalSecond);


                                this.speedProgress = element.speedProgress;

                                this.resourcePath = element.resourcePath;

                                this.studyState = element.studyState;

                                this.classHour = element.classHour;

                                this.chapterName = element.chapterName;
                                this.courseType = element.courseType;

                                this.videoPlay(element.resourcePath, element.totalSecond);

                                courseChapterVoObjectEnter.state = 2;

                                this.lastIndex = index;  //将第一次进来播放的章节下标 放入lastIndex 方便章节切换的时候保留最高播放进度
                                this.flag = false; //用于控制循环只进来一次

                            }

                            courseChapterVoObjectEnter.classHour = element.classHour;

                            courseChapterVoObjectEnter.courseType = element.courseType;

                            courseChapterVoObjectEnter.schedulePercentage = ((element.speedProgress / element.totalSecond).toFixed(4) * 100).toFixed(2);
                            //章节名称
                            //章节id
                            courseChapterVoObjectEnter.chapterId = element.chapterId;
                            //章节名称
                            courseChapterVoObjectEnter.chapterName = element.chapterName;

                            courseChapterVoObjectEnter.speedProgress = element.speedProgress;

                            //章节总时长
                            courseChapterVoObjectEnter.totalHourMinuteSecond = this.secondToDate(element.totalSecond);
                            courseChapterVoObjectEnter.aleryHourMinuteSecond = this.secondToDate(element.speedProgress);
                            courseChapterVoObjectEnter.totalSecond = element.totalSecond;
                            courseChapterVoObjectEnter.resourcePath = element.resourcePath;
                            courseChapterVoObjectEnter.studyState = element.studyState;
                            this.courseChapterList.push(courseChapterVoObjectEnter);
                        });

                    }

                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })
            }
        }
    }
</script>


<style scoped>
    .m-chapterList .section .ksicon {
        display: block;
        height: 14px;
        width: 16px;
    }

    .m-ctb .tabicon-pos0 {
        width: 15px;
        height: 16px;
        background-position: -123px -662px !important;
    }

    .u-plicon,
    .m-phaseList .phaseicon span,
    .m-phaseList .statusicon .icon,
    .m-phaseList .flag,
    .m-phaseList .introbtn,
    .m-phaseList .typeicon,
    .m-chapterList .chaptericon span,
    .m-chapterList .section .ksicon,
    .m-chapterList .section .flag,
    .m-chapterList .ksinfoicon {
        background: url(//s.stu.126.net/res/images/listIcons.png?0c5329f…) 9999px 9999px no-repeat;
    }

    .m-chapterList .section .flag {
        width: 16px;
        height: 18px;
        margin: 12px 3px 0 3px;
    }

    .m-chapterList .section .kstime {
        color: #bababa;
    }

    .f-fr {
        float: right;
    }

    .m-chapterList .ksinfoicon {
        background: url(//s.stu.126.net/res/images/listIcons.png?0c5329f…) 9999px 9999px no-repeat;
    }

    .m-chapterList .ksinfoicon {
        width: 13px;
        height: 13px;
        margin: 13px 0 0 4px;
    }

    .m-chapterList .ksinfoicon.ksinfoicon-2 {
        background-position: -24px -184px;
    }

    .m-chapterList .section {
        height: 36px;
        line-height: 36px;
        padding: 0 12px;
        cursor: pointer;
        transition: all 0.15s ease-out;
    }

    .m-chapterList .section .ksinfo {
        height: 36px;
    }

    .f-fl {
        float: left;
    }

    .m-chapterList .section .ksname {
        padding-left: 8px;
        color: #999;
        max-width: 123px;
        height: 36px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .m-chapterList .section .ksicon-0 {
        background-position: -136px -113px;
    }

    .m-chapterList .section .ksw {
        height: 14px;
        width: 14px;
        margin: 11px 0 0 0;
        background: #f5f7fa;
        transition: all 0.15s ease-out;
    }

    .m-chapterList .section-cur .trailer-ks {
        width: 51px;
        color: #fff !important;
        text-align: left;
        font-size: 12px;
    }

    .m-chapterList .section {
        height: 36px;
        line-height: 36px;
        padding: 0 12px;
        cursor: pointer;
        transition: all 0.15s ease-out;
    }

    .m-chapterList .section-cur {
        background: #3a3e4a;
    }

    .m-chapterList {
        border-top: 0;
        text-align: left;
        position: relative;
        z-index: 999;
        padding-bottom: 1em;
        font-size: 12px;
    }

    .m-ctb .tabarea .m-chapterlistBox {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        height: 100%;
        z-index: 100;
        overflow-y: auto;
        zoom: 1;
    }

    .m-ctb .tabarea .bd {
        position: absolute;
        z-index: 1;
        left: 71px;
        top: 0;
        border: none;
        border-left: solid 1px #d3d3d3;
        width: 0;
        height: 100%;
    }

    .m-ctb .tabarea .tabbox {
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

    .m-ctb .tabarea {
        position: absolute;
        top: 142px;
        left: 0;
        width: 320px;
        bottom: 0;
        overflow: hidden;
        background: #f5f7fa;
    }

    .m-ctb .tabicon {
        margin: 15px 5px 0 30px;
    }

    .m-ctb .tabicon-3 {
        width: 15px;
        height: 16px;
        background-position: -40px -688px;
    }

    .m-ctb .tabitem {
        float: left;
        height: 44px;
        width: 106px;
        text-align: center;
        line-height: 44px;
        color: #666;
    }

    .f-fl {
        float: left;
    }

    .m-ctb .tabicon {
        margin: 15px 5px 0 30px;
    }

    .m-ctb .tabitem {
        float: left;
        height: 44px;
        width: 106px;
        text-align: center;
        line-height: 44px;
        color: #666;
    }

    .m-ctb .tabitem-pos {
        color: #fff;
        background: url(//s.stu.126.net/res/images/bg/pos_tab_btn_bg.png?4e89837…) center center no-repeat;
    }

    .m-ctb .tabs {
        height: 75px;
        background: url(//s.stu.126.net/res/images/bg/toolbar_tab_bg.png?cd66e7a…) repeat-x;
        background-color: #f5f7fa;
        font-family: '微软雅黑';
    }

    .f-fr {
        float: right;
    }

    .m-ctb .courseImg {
        width: 120px;
        height: 66px;
        box-shadow: 0px 0px 4px #666;
    }

    a {
        text-decoration: none;
        color: #333;
    }

    .m-ctb .courseImgCover {
        position: relative;
    }


    .f-thide1 {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        -ms-text-overflow: ellipsis;
        width: 51px;
    }

    .f-thide {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        -ms-text-overflow: ellipsis;
    }

    .u-coursetitle p {
        color: #666;
    }

    .f-cb:after,
    .f-cbli li:after {
        display: block;
        clear: both;
        visibility: hidden;
        height: 0;
        overflow: hidden;
        content: ".";
    }

    .u-coursetitle .cmt {
        float: left;
        margin: 7px 0 0 0;
        color: #666;
    }

    .u-coursetitle .starall {
        float: left;
        height: 20px;
        padding: 7px 0 0;
    }

    .u-coursetitle a {
        font-size: 15px;
        display: block;
        color: #333;
    }

    .u-coursetitle {
        width: 165px;
        text-align: left;
        line-height: 19px;
        color: #7c7c7c;
        font-size: 12px;
        text-align: left;
    }

    .f-fl {
        float: left;
    }

    .m-ctb .courseTitle {
        height: 67px;
        overflow: hidden;
    }

    .m-ctb .courseintro {
        height: 98px;
        padding: 15px;
        background: #abadb0;
    }

    .m-ctb {
        width: 320px;
    }

    .g-sd2 {
        position: relative;
        float: right;
        width: 225px;
        margin-left: -225px;
    }

    .g-sd2 {
        box-shadow: 0px 1px 8px #333;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        width: 320px;
        overflow: hidden;
        background: #abadb0;
    }

    .f-cb:after,
    .f-cbli li:after {
        display: block;
        clear: both;
        visibility: hidden;
        height: 0;
        overflow: hidden;
        content: ".";
    }

    .u-hiderightbtn {
        position: absolute;
        right: 0;
        top: 12px;
        width: 23px;
        height: 24px;
        cursor: pointer;
        z-index: 998;
        background-position: 0 -640px;
    }

    .u-edu-h5player {
        width: 100%;
        height: 100%;
    }

    .u-edu-h5player-mainvideo {
        z-index: 2;
        left: 0;
        top: 0;
    }

    /* .ux-video-player .f-pa {
        position: absolute;
    } */

    .u-edu-h5player .bg {
        background: #000;
        z-index: 1;
    }

    .u-edu-h5player {
        position: relative;
        font-size: 14px;
        font-family: "Arial", "Hiragino Sans GB", 微软雅黑, "Helvetica", "sans-serif";
        color: #999;
        overflow: hidden;
    }

    .ux-video-player {
        position: relative;
        width: 100%;
        height: 100%;
        color: #999;
    }

    .m-video-box,
    .m-video-box object,
    .m-video-box embed,
    .m-video-box .j-videobox,
    .m-video-box .j-textbox,
    .m-text-box,
    .m-text-box object,
    .m-text-box embed,
    .m-text-box .j-videobox,
    .m-text-box .j-textbox,
    .m-link-box,
    .m-link-box object,
    .m-link-box embed,
    .m-link-box .j-videobox,
    .m-link-box .j-textbox {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }

    .m-courselearn .learn-box {
        position: absolute;
        width: 100%;
        top: 0;
        bottom: 36px;
        z-index: 101;
        text-align: center;
        overflow: auto;
        background-color: #525050;
    }

    .m-courselb .learn-total {
        bottom: 40px;
        top: 95px;
        left: 20px;
        right: 20px;
        position: absolute;
        z-index: 90;
        box-shadow: 0 1px 5px #303035;
    }

    /* ////float: left; */
    .m-courselb .cl-title .cl-lessonname {
        padding: 0 0 0 8px;
        display: inline-block;

        color: #cccccc;
    }

    /* float: left; */
    .m-courselb .cl-title .cl-lessonnum {
        width: 25px;
        *width: 18px;
        height: 28px;
        color: #161616;
        font-weight: bold;
        display: inline-block;

        text-align: center;
    }

    /* float: left; */
    .m-courselb .cl-title .cl-lesson {
        width: 41px;
        *width: 45px;
        height: 28px;

        display: inline-block;
        color: #999999;
    }

    /* float: left; */
    .m-courselb .cl-title .cl-chapter {
        display: inline-block;
        color: #161616;
        width: 65px;
        height: 28px;
        text-align: center;

    }

    .m-courselearn .cl-title {
        position: absolute;
        top: 54px;
        left: 22px;
    }

    .m-courselb .cl-title {
        background-position: 0 -124px !important;
        line-height: 28px;
        font-size: 12px;
    }

    p {
        display: block;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
    }

    .coursebox,
    .course-learn,
    .m-courselearn {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }

    .m-courselb .course-learn {
        z-index: 100;
    }

    .m-courselb .cl-pre,
    .m-courselb .cl-next {
        position: absolute;
        left: 112px;
        display: block;
        width: 60px;
        height: 32px;
        z-index: 101;
    }

    .m-courselb .cl-pre {
        top: -1px;
        background-position: -7px -730px;
    }

    .coursesprite,
    .m-tb-notes .notenav .navItem.currentDisable,
    .m-ctb .tabicon,
    .m-courselearn .cs-btn,
    .m-courselearn .cs-up,
    .m-courselearn .cs-down,
    .m-courselb .cl-back,
    .m-courselb .cl-pre,
    .m-courselb .cl-next,
    .m-courselb .cl-title,
    .cl-info .clis span,
    .cl-info em.finish,
    .cl-info em.unfinish,
    .cli-base span,
    .course-refer .refer-item .cr-load,
    .course-refer .refer-item .cr-share,
    .u-hiderightbtn {
        background: url(//s.stu.126.net/res/images/courseLearn.png?91dd8ac…) no-repeat 4449px 4449px;
    }

    .m-courselb .cl-back {
        z-index: 101;
        position: absolute;
        top: 13px;
        left: 0;
        display: block;
        width: 106px;
        height: 29px;
        font-size: 12px;
        line-height: 24px;
        color: #484848;
        text-indent: 22px;
        background-position: -16px -375px;
    }

    .m-courselb .cl-bg {
        height: 100%;
        width: 4px;
        border-right: 1px solid #76767a;
        background-color: #333746;
        left: 139px;
        position: absolute;
        top: 0;
        z-index: 98;
    }

    body,
    div,
    dl,
    dt,
    dd,
    ul,
    ol,
    li,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    pre,
    form,
    fieldset,
    input,
    textarea,
    p,
    blockquote,
    th,
    td {
        padding: 0;
        margin: 0;
    }

    .coursebox,
    .course-learn,
    .m-courselearn {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }

    .coursebox {
        z-index: 0;
        right: 320px;
        border-top: 1px solid #666666;
        border-bottom: 1px solid #626262;
        overflow: hidden;
        background: url(//s.stu.126.net/res/images/bg/courseLearn_bg.jpg?18e2d51…) repeat 0 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/train/video.vue